import { Injectable, Type, ViewContainerRef } from '@angular/core';
import { IDynamicComponent } from './dynamic.component';

export type Attributes = { [key: string]: string };

@Injectable({
  providedIn: 'root',
})
export class DynamicComponentService {
  loadComponent<T = unknown>(
    vcr: ViewContainerRef,
    type: Type<IDynamicComponent<T>>,
    data: T,
    attributes?: Attributes,
  ): void {
    const componentRef = vcr.createComponent(type);
    componentRef.instance.data = data;
    if (attributes) {
      Object.entries(attributes).forEach(([key, value]) => {
        componentRef.location.nativeElement.setAttribute(key, value);
      });
    }
  }
}
